import { render, staticRenderFns } from "./Advantages.vue?vue&type=template&id=3e6b4e75&scoped=true&"
import script from "./Advantages.vue?vue&type=script&lang=js&"
export * from "./Advantages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6b4e75",
  null
  
)

export default component.exports